<template>
    <section class="shoe-products">

        <div class="section-heading">
            <h1>Our Shoes</h1>
            <p>Find the perfect leather shoe for every occasion and attire.</p>
        </div>

        <div class="shoes-container">

            <!-- Shoe 1 -->
            <div class="shoe-card">
                <img :src="monarch" alt="Monarch Shoes">

                <div class="shoe-info">
                    <h3>Monarch Shoe</h3>
                    <p>&#8358;21,000</p>
                    <button @click="viewProduct(17)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Shoe 2 -->
            <div class="shoe-card">
                <img :src="lace" alt="Lace Shoes">

                <div class="shoe-info">
                    <h3>Lace Shoe</h3>
                    <p>&#8358;25,000</p>
                    <button @click="viewProduct(18)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Shoe 3 -->
            <div class="shoe-card">
                <img :src="ranger" alt="Ranger Shoes">

                <div class="shoe-info">
                    <h3>Ranger Shoe</h3>
                    <p>&#8358;30,000</p>
                    <button @click="viewProduct(19)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Shoe 4 -->
            <div class="shoe-card">
                <img :src="stride" alt="Stride Shoes">

                <div class="shoe-info">
                    <h3>Stride Shoe</h3>
                    <p>&#8358;34,000</p>
                    <button @click="viewProduct(20)">
                        View Details
                    </button>
                </div>
            </div>

        </div>

        <div class="shoes-container">

            <!-- Shoe 5 -->
            <div class="shoe-card">
                <img :src="maverick" alt="Maverick Shoes">

                <div class="shoe-info">
                    <h3>Maverick Shoe</h3>
                    <p>&#8358;29,000</p>
                    <button @click="viewProduct(21)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Shoe 6 -->
            <div class="shoe-card">
                <img :src="poise" alt="Poise Shoes">

                <div class="shoe-info">
                    <h3>Poise Shoe</h3>
                    <p>&#8358;28,000</p>
                    <button @click="viewProduct(22)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Shoe 7 -->
            <div class="shoe-card">
                <img :src="madam" alt="Madam Shoes">

                <div class="shoe-info">
                    <h3>Madam Shoe</h3>
                    <p>&#8358;30,000</p>
                    <button @click="viewProduct(23)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Shoe 8 -->
            <div class="shoe-card">
                <img :src="empress" alt="Empress Shoes">

                <div class="shoe-info">
                    <h3>Empress Shoe</h3>
                    <p>&#8358;41,000</p>
                    <button @click="viewProduct(24)">
                        View Details
                    </button>
                </div>
            </div>

        </div>

    </section>
</template>


<script>
export default {

    data() {
        return {
            madam: require('../assets/themadam.jpg'),
            maverick: require('../assets/themaverick.avif'),
            ranger: require('../assets/theranger.avif'),
            poise: require('../assets/thepoise.avif'),
            stride: require('../assets/thestride.avif'),
            monarch: require('../assets/themonarch.avif'),
            empress: require('../assets/theempress.avif'),
            lace: require('../assets/thelace.avif')
        }
    },

    methods: {
        viewProduct(id) {
            this.$router.push('/product/' + id)
        }
    }

}
</script>

<style scoped>
.shoe-products {
  padding: 80px 8%;
  background-color: #ffffff;
}

.section-heading {
  text-align: center;
  margin-bottom: 45px;
}

.section-heading h2 {
  font-size: 36px;
  color: #292929;
  margin-bottom: 10px;
}

.section-heading p {
  color: #4a4541;
}

.shoes-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
}

.product-details{
  position: absolute;
  bottom: 20px;
  right: 15px;
  width: 180px;
  background:white;
  border-radius: 8px;
  color: #333;
  padding: 15px;
  z-index: 2;
  box-shadow: 0 4px 12px rgba (0, 0, 0, 0.2);

  box-sizing: border-box;
}


product-details button:first-of-type {
  background-color: #c66a4a;
  color: white;
}

.product-details button:last-of-type {
  background-color: #333;
  color: white;
  margin-left: 5px;
}

.product-details h5 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}

.product-details p {
  margin-bottom: 8px;
  font-size: 14px;
}
.product-details button {
  border: none;
  padding: 8px 12px;
  margin-top: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  transition: 0.2s ease;
}
.product-details button:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}

.shoe-card {
  background-color: #f5f0e8;
  overflow: hidden;
  transition: 0.3s;
}

.shoe-card:hover {
  transform: translateY(-5px);
}

.shoe-card img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.shoe-info {
  padding: 20px;
}

.shoe-info h3 {
  color: #292929;
  margin-bottom: 10px;
}

.shoe-info p {
  color: #c96f4a;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.shoe-info button {
  background-color: #c96f4a;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  transition: 0.3s;
}

.shoe-info button:hover {
  background-color: #292929;
}

@media (max-width: 768px) {

  .shoes-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .shoe-card img {
    height: 220px;
  }

  .shoe-info {
    padding: 15px;
  }

}

@media (max-width: 480px) {

  .shoes-container {
    grid-template-columns: 1fr;
  }

  .shoe-card img {
    height: 260px;
  }

}
</style>